import { NgModule } from '@angular/core';
import { PreloadAllModules, Route, RouterModule, Routes, UrlSegment, UrlSegmentGroup } from '@angular/router';

import { AuthGuard } from './guards/auth/auth.guard'; // Auth-Dashboard Auth Guard

function twitterCallbackMatcher(url: UrlSegment[]) {
  if (document.documentURI) {
    // url comes back in format: base + ? + query params + #/validate-twitter
    // match validate-twitter and the end of url
    if (url.length === 1 && url[0].path.match(/validate-twitter$/)) {
      // split to extract the query params
      var queryString = document.documentURI.split(/[\?#]/);
      let params = new URLSearchParams(queryString[1]);
      let oauthToken = params.get('oauth_token');
      let oauthVerifier = params.get('oauth_verifier');

      // return the correctly formatted url
      const retValue = {
        consumed: [
          new UrlSegment(url + `?oauth_token=${oauthToken}&oauth_verifier=${oauthVerifier}`, {})
        ]
      }

      return retValue;
    } else {
      // match validate-url at start of url
      if (url.length == 1 && url[0].path.match(/^validate-twitter/)) {
        return {
          consumed: url,
        };
      }
    }
  }

  return null;
}

const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full'},

  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./pages/dashboard/dashboard.module').then( m => m.DashboardPageModule),
  },
  {
    path: 'auth-dashboard',
    loadChildren: () => import('./pages/auth-dashboard/auth-dashboard.module').then( m => m.AuthDashboardPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'settings',
    loadChildren: () => import('./pages/settings/settings.module').then( m => m.SettingsPageModule),
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./pages/forgot-password/forgot-password.module').then( m => m.ForgotPasswordPageModule)
  },
  {
    path: 'view-lines',
    loadChildren: () => import('./pages/view-lines/view-lines.module').then( m => m.ViewLinesPageModule)
  },
  {
    path: 'enter-lines',
    loadChildren: () => import('./pages/enter-lines/enter-lines.module').then( m => m.EnterLinesPageModule)
  },
  {
    path: 'enter-player-modal',
    loadChildren: () => import('./modals/enter-player-modal/enter-player-modal.module').then( m => m.EnterPlayerModalPageModule)
  },
  {
    path: 'publish-lines-modal',
    loadChildren: () => import('./modals/publish-lines-modal/publish-lines-modal.module').then( m => m.PublishLinesModalPageModule)
  },
  {
    path: 'add-game-modal',
    loadChildren: () => import('./modals/add-game-modal/add-game-modal.module').then( m => m.AddGameModalPageModule)
  },
  {
    path: 'game-info',
    loadChildren: () => import('./pages/game-info/game-info.module').then( m => m.GameInfoPageModule)
  },
  {
    path: 'add-scratch-modal',
    loadChildren: () => import('./modals/add-scratch-modal/add-scratch-modal.module').then( m => m.AddScratchModalPageModule)
  },
  {
    path: 'eula',
    loadChildren: () => import('./pages/eula/eula/eula.module').then( m => m.EulaPageModule)
  },
  {
    path: 'publish-twitter-modal',
    loadChildren: () => import('./modals/publish-twitter-modal/publish-twitter-modal.module').then( m => m.PublishTwitterModalPageModule)
  },
  {
    matcher: twitterCallbackMatcher,
    loadChildren: () => import('./pages/validate-twitter/validate-twitter.module').then( m => m.ValidateTwitterPageModule),
  },
  {
    path: 'validate-twitter',
    loadChildren: () => import('./pages/validate-twitter/validate-twitter.module').then( m => m.ValidateTwitterPageModule)
  },
  {
    path: "**",
    redirectTo: 'dashboard'
  },
  {
    path: 'biometric-setup',
    loadChildren: () => import('./modals/biometric-setup-modal/biometric-setup-modal.module').then( m => m.BiometricSetupModalPageModule)
  },
  {
    path: 'verify-login-modal',
    loadChildren: () => import('./modals/verify-login-modal/verify-login-modal.module').then( m => m.VerifyLoginModalPageModule)
  },
  {
    path: 'dual-auth-modal',
    loadChildren: () => import('./modals/dual-auth-modal/dual-auth-modal.module').then( m => m.DualAuthModalPageModule)
  },
  {
    path: 'add-notes-modal',
    loadChildren: () => import('./modals/add-notes-modal/add-notes-modal.module').then( m => m.AddNotesModalPageModule)
  },  {
    path: 'player-info-modal',
    loadChildren: () => import('./modals/player-info-modal/player-info-modal.module').then( m => m.PlayerInfoModalPageModule)
  },
  {
    path: 'quick-report-modal',
    loadChildren: () => import('./modals/quick-report-modal/quick-report-modal.module').then( m => m.QuickReportModalPageModule)
  },
  {
    path: 'powerplay-summaries-modal',
    loadChildren: () => import('./modals/powerplay-summaries-modal/powerplay-summaries-modal.module').then( m => m.PowerplaySummariesModalPageModule)
  }

];


@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, useHash: true }),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
